import { render, staticRenderFns } from "./dormModifyApprove.vue?vue&type=template&id=51a8c1dc&scoped=true"
import script from "./dormModifyApprove.vue?vue&type=script&lang=js"
export * from "./dormModifyApprove.vue?vue&type=script&lang=js"
import style0 from "./dormModifyApprove.vue?vue&type=style&index=0&id=51a8c1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8c1dc",
  null
  
)

export default component.exports